import * as moment from "moment";
import {
  SisenseCategoryMap,
  SisenseCategoryMapByName,
  TableauCategoryMap,
  TableauCategoryMapByName
} from "@/lib/utilities/enums";

export function convertIdToPubNubKind(id) {
  var self = this;

  if (!id || id.length === 0) return "";

  return id.replace(/:/g, "-");
}

export function alphabeticSort(array) {
  return array.sort(function compare(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  });
}

export function getReadableDuration(minutes) {
  const duration = moment.duration(minutes, "minutes");

  // Get time in HH:MM - Is there a way to do this in moment.js??
  const strHours = Math.floor(duration.asHours())
    .toString()
    .padStart(2, "0");
  const strMinutes = duration
    .minutes()
    .toString()
    .padStart(2, "0");

  return `${strHours}:${strMinutes}`;
}

export function exists(e) {
  return (
    e !== undefined && e !== null && !(typeof e === "string" && e.trim() === "")
  );
}

export const range = (start, end) =>
  end === undefined
    ? Array.from({ length: start }, (v, k) => k)
    : Array.from({ length: end - start }, (v, k) => k + start);

/**
 * Limit the execution of specififed function by the provided milliseconds.
 *    This will provide a trailing call, even with immediate set, if there
 *      was a request sent in the rate-limited time.
 *
 * @param func: Function to execute
 * @param millis: Milliseconds to delay
 * @param immediate: Immediate/leading execution of function.
 * @returns {rateLimited}: Wrapped function
 */
export function rateLimit(func, millis, immediate = true) {
  let pending, lastCall, argsToCallWith, context;
  if (!millis || millis < 0) millis = 100;
  if (!func || typeof func !== "function") {
    console.error("rateLimit: Handler is not a function...");
    func = () => {};
  }

  function callFn(now) {
    pending = undefined;
    lastCall = now ? now : Date.now();
    func.apply(context, argsToCallWith);
  }

  /**
   * Call or create a pending timeout.
   *    When the call is resolved (eg. callFn), the promise will be resolved and lastCall will be set.
   *    recently = now - lastCall > millis
   *
   *    Details:
   *      When this function is called, if there is an existing promise nothing should happen
   *      If you want a leading call on triggers (immediate = true)
   *           You should immediately call the function if you have not called the function recently (now - lastCall > millis)
   *           Otherwise, you should set pending if you have not called recently
   *      If you only want trailing calls (immediate = false)
   *           You should immediately set pending
   *
   * @param args
   */
  function rateLimited(...args) {
    context = this;
    argsToCallWith = args;
    if (!pending) {
      const now = Date.now();
      const since = now - lastCall;

      if (immediate) {
        if (!lastCall || since >= millis) callFn(now);
        else pending = setTimeout(callFn, millis - since);
      } else pending = setTimeout(callFn, millis - since);
    }
  }

  return rateLimited;
}

export function arrayToObj(arr, key = "id") {
  if (!Array.isArray(arr)) {
    console.warn("Invalid array passed to arrayToObj... Exiting.");
    return {};
  }

  return arr.reduce((prev, curr) => {
    if (!exists(curr[key]))
      console.warn(`arrayToObj: No value for curr[${key}]. Ignoring.`);
    else prev[curr[key]] = curr;
    return prev;
  }, {});
}

export function lookupSisenseCategory(categoryId) {
  return SisenseCategoryMap[categoryId] || SisenseCategoryMapByName.Other;
}

export function lookupTableauCategory(categoryId) {
  return TableauCategoryMap[categoryId] || TableauCategoryMapByName.Other;
}



// WEBPACK FOOTER //
// ./src/lib/utilities/index.js